import axios from 'axios';
import { DEFAULT_MESSAGE_UNEXPECTED_ERROR } from '../const/Const';
export const getSiteProcessList = (
  construct_id: number,
  parent_only?: boolean,
  start_date?: string | null,
  end_date?: string | null,
  page?: number,
  display_limit?: number
) => {
  return axios
    .get(`/api/v1/process`, {
      params: {
        construct_id,
        parent_only,
        start_date,
        end_date,
        page,
        display_limit
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getSiteProcessNameList = (
  construct_id: number,
  parent_only: boolean = false
) => {
  return axios
    .get(`/api/v1/process/name-list`, {
      params: {
        construct_id,
        parent_only
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createSiteProcess = (
  site_process_name: string,
  construct_id: number,
  start_date: string,
  parent_site_process_id?: number | null,
  charge_user_id?: number | null,
  end_date?: string | null,
  planned_man_day?: number | null,
  note?: string | null
) => {
  return axios
    .post(
      `/api/v1/process/create`,
      {
        parent_site_process_id,
        site_process_name,
        construct_id,
        charge_user_id,
        start_date,
        end_date,
        planned_man_day,
        note
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
export const deleteSiteProcess = (site_process_id: number) => {
  return axios
    .post(
      `/api/v1/process/delete`,
      {
        site_process_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getSiteProcessDetail = (site_process_id: number) => {
  return axios
    .get(`/api/v1/process/${site_process_id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateSiteProcess = (
  site_process_id: number,
  site_process_name: string,
  construct_id: number,
  start_date: string,
  status: number,
  parent_site_process_id?: number | null,
  charge_user_id?: number | null,
  end_date?: string | null,
  planned_man_day?: number | null,
  actual_man_day?: number | null,
  note?: string | null
) => {
  return axios
    .put(
      `/api/v1/process/update`,
      {
        site_process_id,
        site_process_name,
        construct_id,
        start_date,
        status,
        parent_site_process_id,
        charge_user_id,
        end_date,
        planned_man_day,
        actual_man_day,
        note
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const exportSiteProcessListExcel = (construst_id: number) => {
  return axios
    .post(
      `/api/v1/process/export/excel/list`,
      {
        construct_id: construst_id
      },
      {
        headers: {
          withCredentials: true
        },
        responseType: 'blob'
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        // エラーの場合はBlobをJSONに変換→オブジェクトに変換する
        return err.response.data.text().then((text: any) => {
          const data = JSON.parse(text);
          if (
            data.error &&
            data.error === 'Missing cookie access_token_cookie'
          ) {
            return 'Not logged in!';
          } else if (data.error) {
            return data;
          } else {
            return DEFAULT_MESSAGE_UNEXPECTED_ERROR;
          }
        });
      } else {
        return err.response;
      }
    });
};

export const exportSiteProcessGanttExcel = (
  construst_id: number,
  start_date?: string | null,
  end_date?: string | null
) => {
  return axios
    .post(
      `/api/v1/process/export/excel/gantt`,
      {
        construct_id: construst_id,
        start_date: start_date,
        end_date: end_date
      },
      {
        headers: {
          withCredentials: true
        },
        responseType: 'blob'
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        // エラーの場合はBlobをJSONに変換→オブジェクトに変換する
        return err.response.data.text().then((text: any) => {
          const data = JSON.parse(text);
          if (
            data.error &&
            data.error === 'Missing cookie access_token_cookie'
          ) {
            return 'Not logged in!';
          } else if (data.error) {
            return data;
          } else {
            return DEFAULT_MESSAGE_UNEXPECTED_ERROR;
          }
        });
      } else {
        return err.response;
      }
    });
};

// 工程コピー用の工事一覧取得
export const getConstructionsForSiteProcessCopy = () => {
  return axios
    .get(`/api/v1/process/copy/constructions`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 工程コピー
export const copySiteProcess = (
  current_construct_id: number,
  target_construct_id: number,
  copy_target: number
) => {
  return axios
    .post(
      `/api/v1/process/copy`,
      {
        current_construct_id,
        target_construct_id,
        copy_target
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// 工程入れ替え
export const updateOrderChange = (
  resources_id: string,
  resources_order_id: number
) => {
  return axios
    .put(
      `/api/v1/process/update/order`,
      {
        id: resources_id,
        order_id: resources_order_id
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getConstructionExpectedDates = (construct_id: number) => {
  return axios
    .get(`/api/v1/constructions/${construct_id}/expected-dates`, {
      headers: {
        withCredentials: true
      }
    })
    .then(response => {
      return response.data;
    })
    .catch(err => {
      if (err.response?.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else {
          return err.response.data;
        }
      } else {
        return err.response;
      }
    });
};

export const updateConstructionExpectedDates = (
  construct_id: number,
  expected_contract_date: string,
  expected_end_date: string
) => {
  return axios
    .put(
      `/api/v1/constructions/${construct_id}/expected-dates`,
      {
        expected_contract_date,
        expected_end_date
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(response => {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else {
        return err.response;
      }
    });
};
// 工程全削除
export const deleteAllSiteProcesses = (construct_id: number) => {
  return axios
    .post(
      `/api/v1/process/delete/all`,
      {},
      {
        params: { construct_id },
        headers: {
          withCredentials: true
        }
      }
    )
    .then(res => res.data)
    .catch(err => {
      if (err.response?.data?.error === 'Missing cookie access_token_cookie') {
        return 'Not logged in!';
      } else {
        return err.response?.data || err.response;
      }
    });
};
